var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pl-0" },
    [
      _c("entity-nav", { attrs: { navItems: _vm.navItems, useEvents: "" } }),
      _c(
        "div",
        { staticClass: "entityView" },
        [
          _c(
            "keep-alive",
            { attrs: { exclude: "RitualCircleReader" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }